import { request } from './client';

/**
 * Who is told when a visit of a given kind is handed in.
 *
 * One list per visit type, saved whole: the screen shows To and Cc together and saves them
 * together, so there is no route for adding a single address — which would make "remove the
 * last one" a different call from "clear the list" for no reason anybody could explain.
 */

const base = '/api/v1/parameters/mail-recipients';

export interface VisitMailRecipients {
  visitTypeId: string;
  visitTypeName: string;
  to: string[];
  cc: string[];
}

export interface SaveVisitMailRecipients {
  to: string[];
  cc: string[];
}

export const mailSettings = {
  /** Every active visit type, including the ones with no addresses at all. */
  list: () => request<VisitMailRecipients[]>(base),

  save: (visitTypeId: string, body: SaveVisitMailRecipients) =>
    request<VisitMailRecipients>(`${base}/${visitTypeId}`, {
      method: 'PUT',
      body: JSON.stringify(body),
    }),
};
